<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="toc-title">Table of Contents</p>
<p class="toc"><a href="#/xhtml/fm2">Publisher’s Note</a></p>
<p class="toc"><a href="#/xhtml/foreword">Foreword</a></p>
<p class="toc"><a href="#/xhtml/introduction">Introduction</a></p>
<p class="toc"><a href="#/xhtml/chapter01">Calling My Name</a></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Trouble the Waters</span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">An Acquaintance with Grief</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Soon One Morning</span></p>
<p class="toc"><span href="#/xhtml/bm" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/bm1" title="Link target outside of Sample">The Dead Call Us to Remember</span></p>
<p class="toc"><span href="#/xhtml/bm2" title="Link target outside of Sample">Afterword</span></p>
<p class="toc"><span href="#/xhtml/bm3" title="Link target outside of Sample">Resources</span></p>
<p class="toc"><span href="#/xhtml/acknowledgement" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc"><span href="#/xhtml/aboutauthor" title="Link target outside of Sample">About the Author</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a91d96b6